module.exports = __webpack_public_path__ + "img/Group 97842.59aa7ff4.png";